
import Vue from 'vue';

export default Vue.extend({
	props: {
		loadingStatus: { type: Boolean, default: false },
		spinnerColor: { type: String, default: 'primary' },
	},
});
